import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, HStack, Modal, Text, Box, Pressable, Center } from "native-base";
import Trackable from "../../common/Trackable";
import i18next from "i18next";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import BrandIcon from "../../common/BrandIcon";

var DeliveryUnavailableModal = function DeliveryUnavailableModal(_ref) {
  var _store$delivery, _store$delivery$deliv;

  var isOpen = _ref.isOpen,
      _onClose = _ref.onClose,
      resetAndClose = _ref.resetAndClose;
  var store = useStore();
  var isMobile = store.isMobile;
  var restaurantNumber = (_store$delivery = store.delivery) === null || _store$delivery === void 0 ? void 0 : (_store$delivery$deliv = _store$delivery.deliveryModel) === null || _store$delivery$deliv === void 0 ? void 0 : _store$delivery$deliv.previousRestaurantNumber;
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onClose: function onClose() {
      return _onClose();
    },
    bg: "rgba(0,0,0,0.4)",
    children: /*#__PURE__*/_jsxs(Modal.Content, {
      maxWidth: "420px",
      p: 0,
      bg: "modalLightBg",
      children: [/*#__PURE__*/_jsx(Modal.Header, {
        bg: "emptyCartHeaderBgColor",
        roundedTop: 7,
        p: 0,
        children: /*#__PURE__*/_jsxs(HStack, {
          py: 5,
          _web: {
            ml: isMobile ? [0, "27px", "27px"] : "27px"
          },
          alignItems: "center",
          justifyContent: isMobile ? ["center", "flex-start", "flex-start"] : "flex-start",
          position: "relative",
          children: [/*#__PURE__*/_jsx(Text, {
            textAlign: "center",
            fontSize: isMobile ? "md" : "lg",
            lineHeight: 4,
            color: "modalTextColor",
            fontWeight: 400,
            children: i18next.t("togo.deliveryUnavailableModal.title", {
              defaultValue: "We're Sorry"
            })
          }), /*#__PURE__*/_jsx(Box, {
            position: "absolute",
            right: 6,
            children: /*#__PURE__*/_jsx(Trackable, {
              className: "trackContent",
              dataLinkInfo: "togo delivery unavailable modal|close icon",
              children: /*#__PURE__*/_jsx(Pressable, {
                onPress: function onPress() {
                  return _onClose();
                },
                children: /*#__PURE__*/_jsx(BrandIcon, {
                  iconName: "close",
                  alt: "CloseIcon",
                  height: "20px",
                  width: "20px"
                })
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Modal.Body, {
        _web: {
          px: isMobile ? "20px" : "27px",
          py: isMobile ? "20px" : "22px"
        },
        children: /*#__PURE__*/_jsxs(Center, {
          children: [/*#__PURE__*/_jsx(BrandIcon, {
            iconName: "exception",
            alt: "time",
            _web: {
              height: "65px",
              width: "65px"
            },
            mr: 1.5,
            mt: .5,
            py: 2
          }), /*#__PURE__*/_jsx(Text, {
            pt: 4,
            color: "#4E311D",
            fontSize: 28,
            fontWeight: 500,
            textAlign: "center",
            children: i18next.t("togo.deliveryUnavailableModal.text1", {
              defaultValue: "Delivery is currently unavailable"
            })
          }), /*#__PURE__*/_jsx(Text, {
            fontSize: "md",
            fontWeight: 300,
            lineHeight: 6,
            textAlign: "center",
            color: "modalTextColor",
            py: 4,
            px: 2,
            children: i18next.t("togo.deliveryUnavailableModal.text2", {
              defaultValue: "Switch to Pickup to continue with your order and you can pick up from your nearest Olive Garden location."
            })
          }), /*#__PURE__*/_jsx(Box, {
            width: "100%",
            children: /*#__PURE__*/_jsx(Trackable, {
              className: "trackContent",
              dataLinkInfo: "togo delivery unavailable modal|switch to pickup cta",
              children: /*#__PURE__*/_jsx(Button, {
                pb: 2,
                mt: 2,
                _text: {
                  textTransform: "uppercase",
                  color: "white",
                  lineHeight: 6,
                  fontSize: "md",
                  fontWeight: 300
                },
                onPress: function onPress() {
                  var _store$delivery2;

                  _onClose();

                  store === null || store === void 0 ? void 0 : (_store$delivery2 = store.delivery) === null || _store$delivery2 === void 0 ? void 0 : _store$delivery2.deliveryToPickupSwitch(restaurantNumber);
                },
                children: i18next.t("togo.deliveryUnavailableModal.pickupText", {
                  defaultValue: "Switch to pickup"
                })
              })
            })
          })]
        })
      })]
    })
  });
};

export default observer(DeliveryUnavailableModal);